module.exports = __webpack_public_path__ + "static/media/Office_main.b84e38e9.jpg";